import React from 'react'
import HeaderV2 from '../ui/HeaderV2'
import Section from '../ui/Section'
import Container from '../ui/Container'
import Grid from '../ui/Grid'
import Footer from '../ui/Footer'
import {Link} from 'react-router-dom'

class Thankyou extends React.Component {
    render(){
        return(
            <>
                <HeaderV2 />
                <Section className="c_top-section">
                    <Container>
                        <Grid>
                            <h2 className="c_section-heading">THANK YOU</h2>
                            <div className="c_copy">
                                <p>Thank you for contacting us. Someone from our team will get in touch with you shortly.</p>
                            </div>
                            <Link to="/" className="c_button">Home</Link>
                        </Grid>
                    </Container>
                </Section>
                <Footer />
            </>
        )
    }
}

export default Thankyou